export const APPROVALS_PENDING_CHANGED_EVENT = "approvals-pending-changed";
const BROADCAST_CHANNEL = "naseebi-approvals-pending";

function makeEventId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/**
 * @param {{ delta?: number }} [detail]
 */
export function notifyApprovalsPendingChanged(detail = {}) {
  if (typeof window === "undefined") return;
  const payload = { ...detail, _id: makeEventId() };
  // Same-tab listeners
  window.dispatchEvent(
    new CustomEvent(APPROVALS_PENDING_CHANGED_EVENT, { detail: payload })
  );
  // Cross-tab only — other tabs receive BroadcastChannel; we ignore echo locally via _id
  try {
    const bc = new BroadcastChannel(BROADCAST_CHANNEL);
    bc.postMessage(payload);
    bc.close();
  } catch {
    // BroadcastChannel not available in some environments.
  }
}

export function subscribeApprovalsPendingChanged(handler) {
  if (typeof window === "undefined") return () => {};

  const seenIds = new Set();
  const wrap = (detail = {}) => {
    const id = detail?._id;
    if (id) {
      if (seenIds.has(id)) return;
      seenIds.add(id);
      window.setTimeout(() => seenIds.delete(id), 2000);
    }
    handler(detail);
  };

  const onWindow = (event) => wrap(event?.detail || {});
  window.addEventListener(APPROVALS_PENDING_CHANGED_EVENT, onWindow);

  let bc = null;
  try {
    bc = new BroadcastChannel(BROADCAST_CHANNEL);
    bc.onmessage = (event) => wrap(event?.data || {});
  } catch {
    // ignore
  }

  return () => {
    window.removeEventListener(APPROVALS_PENDING_CHANGED_EVENT, onWindow);
    if (bc) {
      bc.onmessage = null;
      bc.close();
    }
  };
}
